import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import DiagnosticTest from './components/DiagnosticTest.jsx';
import './styles/global.css';

// Enhanced error handling for deployment
function renderApp() {
  try {
    const container = document.getElementById('root');
    
    if (!container) {
      console.error('❌ Root container not found! The div with id="root" is missing from the HTML.');
      // Create debug info in body if root is missing
      document.body.innerHTML = `
        <div style="background: #f8d7da; border: 2px solid red; padding: 20px; margin: 20px; font-family: monospace;">
          <h2>❌ React Mount Error</h2>
          <p><strong>Problem:</strong> Cannot find div with id="root"</p>
          <p><strong>Current HTML Body:</strong></p>
          <pre>${document.body.innerHTML}</pre>
          <p><strong>URL:</strong> ${window.location.href}</p>
          <p><strong>Timestamp:</strong> ${new Date().toISOString()}</p>
        </div>
      `;
      return;
    }

    console.log('✅ Root container found, creating React root...');
    const root = createRoot(container);
    
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
    
    console.log('✅ React app rendered successfully');
    
  } catch (error) {
    console.error('❌ Error rendering React app:', error);
    
    // Fallback error display
    const container = document.getElementById('root') || document.body;
    container.innerHTML = `
      <div style="background: #f8d7da; border: 2px solid red; padding: 20px; margin: 20px; font-family: monospace;">
        <h2>❌ React Render Error</h2>
        <p><strong>Error:</strong> ${error.message}</p>
        <p><strong>Stack:</strong></p>
        <pre>${error.stack}</pre>
        <p><strong>URL:</strong> ${window.location.href}</p>
        <p><strong>Timestamp:</strong> ${new Date().toISOString()}</p>
      </div>
    `;
  }
}

// Wait for DOM to be ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', renderApp);
} else {
  renderApp();
}

// Also render to test root if it exists
const testContainer = document.getElementById('react-test-root');
if (testContainer) {
  const testRoot = createRoot(testContainer);
  testRoot.render(
    <React.StrictMode>
      <DiagnosticTest />
    </React.StrictMode>
  );
}
